module.exports = __webpack_public_path__ + "assets/RetinaNarr-Medium.e08c459a519315fcc6b4a26d2b6c8a4a.woff2";